import qs from 'qs'

const fields = [
  'date_posted'

]

export const queryEssayEntryBySlug = (options: QueryBySlugOrIdOptions) => {
  const searchKey = strapiGetI18nSlug(options.locale)

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      locale: options?.locale || 'en-US',
      pagination: {
        limit: 1,
      },
      filters: {
        slugs: {
          [searchKey]: {
            $eq: options.slug
          }
        }
      },
      fields,
      populate: {
        ...queryFragmentCollectionTypeDefault,
        ...queryFragmentBlocks,
        authors: true,
        cover_image: true,
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `essay-entries?${query}`
}
